var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"mt-2",attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"12","lg":"10","md":"10"}},[_c('budget-preview')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }